import styles from "./CardLinkOverlay.module.scss";
import { CustomLink } from "@/components/CustomLink.tsx";
import type { GetLabel } from "@/getData/fetchData.server.ts";
import { optimizeURL } from "@/utils/url.ts";
import { LinkType } from "@/types/baseTypes.ts";

type CardLinkOverlayProps = {
  title?: string;
  link: string | LinkType | undefined;
  getLabel: GetLabel;
};

const CardLinkOverlay = ({ title, link, getLabel }: CardLinkOverlayProps) => {
  const readMoreLabel = getLabel("read_more_label");

  if (!link) return null;

  const actualLink = typeof link === "string" ? link : link.url;

  return (
    <CustomLink
      href={optimizeURL(actualLink) || actualLink}
      className={`${styles["link-overlay"]}`}
      target="_self"
      aria-label={`${readMoreLabel}${title ? `: ${title}` : ""}`}
      disablePrefetch // Disable prefetching for grid links https://trello.com/c/g5k075FS
    >
      <span className={"sr-only"}>{readMoreLabel}</span>
    </CustomLink>
  );
};

export default CardLinkOverlay;
